import { render } from "./progress-ring-icon.vue.js?vue&type=template&id=0a7db45a!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./progress-ring-icon.vue?vue&type=template&id=0a7db45a"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__